import { render } from "./App.vue?vue&type=template&id=deb72bd0&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=deb72bd0&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=deb72bd0&lang=scss"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deb72bd0"]])

export default __exports__